import { CalculationBaseService } from '../gen/service/calculation-base-service'

export class CalculationService extends CalculationBaseService {}
